//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Topic } from "@/models";
import TopicHeader from "@/components/topic/JielongTopicHeader.vue";
import JielongTopicReply from "@/components/topic_reply/JielongTopicReply.vue";
import JielongTopicBottomBar from "@/components/topic/JielongTopicBottomBar.vue";
import AddJielongTopicReplyPopup from "@/components/topic/AddJielongTopicReplyPopup.vue";
import { mapGetters } from "vuex";

export default {
  name: "JielongTopic",
  created() {
    let id = this.$route.params.id;

    Topic.getById(id).then(topic => {
      this.topic = topic;
    });

    this.getLatestTopicReplies();
  },
  data() {
    return {
      topic: null,
      replies: [],
      repliesPage: 1,
      loading: false,
      showReplyPopup: false,
      showSubmitSuccessTip: false
    };
  },
  scrollBottom() {
    if (this.loading) {
      return;
    }

    this.getLatestTopicReplies(this.repliesPage + 1);
  },
  methods: {
    getLatestTopicReplies: function(page = 1) {
      let id = this.$route.params.id;

      this.loading = true;
      Topic.getLatestReplies(id, page)
        .then(replies => {
          if (page == 1) {
            this.replies = replies;
          } else {
            this.replies = this.replies.concat(replies);
          }

          this.repliesPage = page;
          this.loading = false;
        })
        .catch(err => {
          this.loading = false;
        });
    },
    reply: function() {
      if (!this.user) {
        return;
      }

      this.showReplyPopup = true;
    },
    didSubmitJielong: function(reply) {
      reply.fetch({ include: "user, work" }).then(() => {
        this.replies.splice(0, 0, reply);
      });
    }
  },

  computed: {
    ...mapGetters(["user"])
  },
  components: {
    TopicHeader,
    JielongTopicReply,
    JielongTopicBottomBar,
    AddJielongTopicReplyPopup
  }
};



// WEBPACK FOOTER //
// ./src/pages/JielongTopic.vue